import React, { useState } from 'react';
import {
  Box,
  Paper,
  Tabs,
  Tab,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import {
  AccessTime as AttendanceIcon,
  Assessment as ReportIcon,
  Settings as SettingsIcon,
  MoreVert as MoreVertIcon,
  Refresh as RefreshIcon,
  Download as DownloadIcon,
  Print as PrintIcon
} from '@mui/icons-material';
import StudentAttendance from './studentAttendance';
import StudentAttendanceReports from './studentAttendanceReports';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`student-attendance-tabpanel-${index}`}
      aria-labelledby={`student-attendance-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default function StudentAttendanceDashboard() {
  const [tabValue, setTabValue] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleExport = () => {
    // Export functionality
    console.log('Export data');
    handleMenuClose();
  };

  const handlePrint = () => {
    // Print functionality
    window.print();
    handleMenuClose();
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Header */}
    

      {/* Tabs */}
     

      {/* Tab Panels */}
      <TabPanel value={tabValue} index={0}>
        <StudentAttendance />
      </TabPanel>
      
      <TabPanel value={tabValue} index={1}>
        <StudentAttendanceReports />
      </TabPanel>
    </Box>
  );
}
